// src/redux/slices/iframeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  interpreterIframeUrl: null,
};

const interpreterIframeSlice = createSlice({
  name: "interpreterIframe",
  initialState,
  reducers: {
    setInterpreterIframeUrl: (state, action) => {
      state.interpreterIframeUrl = action.payload;
    },
    clearInterpreterIframeUrl: (state) => {
      state.interpreterIframeUrl = null;
    },
  },
});

export const { setInterpreterIframeUrl, clearInterpreterIframeUrl } = interpreterIframeSlice.actions;
export default interpreterIframeSlice.reducer;
